import { useSelector } from '@xstate/react'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import MultiCartBookedByLabel from './MultiCartBookedByLabel'
import MultiCartAddedByLabel from './MultiCartAddedByLabel'
import { isSharedMultiCart } from 'lib/userCart/multiCartVisibility'

interface Props {
  item: App.MultiCartItem
}

function MultiCartParticipantLabel({ item }: Props) {
  const multiCartActorRef = MultiCartContext.useActorRef()
  const activeCartId = useSelector(multiCartActorRef, (snapshot) => snapshot.context.activeCartId)
  const cartSummary = useSelector(multiCartActorRef, (snapshot) => {
    if (snapshot.context.cartSummary.status === 'loaded' && activeCartId) {
      return snapshot.context.cartSummary.data[activeCartId]
    }
  })

  if (!isSharedMultiCart(cartSummary)) {
    return null
  }

  return <>
    {item.purchasedBy && <MultiCartBookedByLabel name={item.purchasedBy.givenName} />}
    {!item.purchasedBy && item.createdBy && <MultiCartAddedByLabel name={item.createdBy.givenName} />}
  </>
}

export default MultiCartParticipantLabel
